const translation = {
  cart: {
    mainDomain: 'Dominio principal ',
    pendingDomain: 'Pendiente por asignar',
    associateDomain: 'Dominio asociado ',
    btn: {
      edit: 'Editar'
    },
    step:{
      1: 'Configuración de producto',
      2: 'Revisa y confirma tu pago'
    },
    config:{
      title: 'Configuración de producto',
      plan_seleccionado: 'Tu Plan Seleccionado:',
      hosting: {
        title: 'Selecciona el periodo de tu plan',
        text: 'Elige por cuánto tiempo deseas contratar tu servicio:'
      },
      vps: {
        title: 'Para terminar de configurar tu VPS',
        text: 'Completa la configuración seleccionando tu sistema operativo.',
        disclaimer: 'Elige sabiamente, ya que el SO define la eficiencia y seguridad de tu servidor. ¡No dejes pasar la oportunidad de optimizar tu experiencia y maximizar el rendimiento!'
      },
      ssl: {
        title: 'ejemplo.com (sin www)',
        text: "Asegúrate de ingresar el Dominio sin el <b>'www'</b> y escribirlo con su extensión correspondiente.",
        disclaimer: {
          remember: '** Recuerda:',
          text: 'El certificado SSL se asocia con el Dominio elegido y no se puede transferir. Tenlo presente al elegir el Dominio.'
        },
        input: {
          placeholder: 'Ingresar el  dominio al que desear proteger...'
        }
      },
      domain: {
        title: 'Selecciona un Dominio para tu Servicio:',
        text: 'Complementa la identidad de tu proyecto con un Dominio personalizado o utiliza uno ya registrado.',
        principal: 'Dominio Principal',
        mas_opciones: 'Ver más opciones',
        ya_domain: 'Tu dominio ya se encuentra en el carrito.',
        register: {
          label: 'Registra un nuevo Dominio.',
          placeholder: 'Buscar Dominio...',
          btn: 'Buscar'
        },
        transfer: {
          label: 'Ya tengo un Dominio con otro proveedor y quiero transferirlo a NEUBOX.',
          placeholder: 'Ingresa un Dominio para transferir...',
          btn: 'Transferir',
          success_message: 'Una vez completada tu compra, continuaremos con el proceso de transferencia. Por favor, <b>asegúrate de ingresar correctamente</b> el nombre de Dominio a transferir.',
          disclaimer: 'Los resultados de disponibilidad de dominio se almacenan en caché (datos almacenados temporalmente), lo que puede llevar a que los dominios registrados recientemente se muestren disponibles.',
          addDomain: 'Agrega un plan Hosting a tu Dominio'
        },
        no_domain: {
          label: 'Ya tengo un Dominio pero no quiero transferirlo a NEUBOX.',
          placeholder: 'Escribe tu Dominio aquí...',
          btn: "Usar"
        },
        agregado: {
          label: 'Usar un Dominio que ya está en mi carrito de compras',
          btn: 'Usar',
        },
        already_exist:'El dominio ya está en el carrito.',
        not_valid: 'El nombre de dominio proporcionado no es válido. Proporciona sólo la parte después de www. e incluye la extensión de dominio.',
        not_valid_tld: 'La extensión del dominio que ingresaste no está disponible. Verifica que esté escrita correctamente o intenta con otra extensión.',
      }
    },
    transfer: {
      title: "Transfiere tu dominio con nosotros.",
      text: "Asegura la gestión de tu dominio en una sola plataforma y disfruta de beneficios diseñados para impulsar tu proyecto. ¡Comienza hoy mismo!"
    },
    hidden: {
      error: {
        title: 'Este producto no está disponible.',
        text: 'Te redirigiremos al carrito.'
      }
    }
  },
  loginbase: {
    loginTitle: 'Iniciar sesión',
    signupTitle: 'Registrarme',
  },
  loggedin:{
    rfc:{
      info: "Recuerda que facturaremos tu compra bajo el RFC: {{ rfc }}. Si prefieres, puedes ",
      btnText: 'OMITIR POR ESTA OCASIÓN',
      modalTitle: 'Omitir Factura',
      modalText: '¿Deseas omitir la facturación para esta compra? No se generará factura bajo el RFC: {{ rfc }} por esta ocasión.',
      modalButtonConfirm: 'Sí, omitir'
    }
  },
  // Component ButtonCopy
  component_button_copy: {
    success: "¡Texto copiado!",
    error: "Ocurrió un error al copiar texto",
  },
  modal: {
    text: "Por favor, espere un momento mientras procesamos su método de pago. Estamos asegurándonos de que todo esté listo para completar su transacción."
  },
  // spei
  spei: {
    pago_pendiente: "PENDIENTE DE PAGO",
    title: "¡Gracias por elegir NEUBOX!",
    subtitle:
      "Para completar tu compra mediante <strong>transferencia SPEI</strong>, utiliza la siguiente información bancaria para realizar la transferencia desde tu banco o plataforma de banca en línea. Sin esta información, no podremos validar tu compra.",
    btn: {
      copy: "Copiar",
      download: "Descargar",
      continue: "Continuar"
    },
    remember: {
      title: "¡RECUERDA!",
      li_1: "Accede a tu cuenta bancaria en línea o a través de la app de tu banco y selecciona la opción de <strong>transferencia SPEI</strong>.",
      li_2: "Ingresa la <strong>cuenta CLABE que aparece en tu recibo</strong>. Esta cuenta es exclusiva para tu pago en <strong>NEUBOX</strong>.",
      li_3: "Asegúrate de transferir el monto total que aparece en tu recibo para evitar retrasos en la activación de tus servicios.",
      li_4: "<strong>Copia y pega la referencia indicada</strong> en tu recibo. Esta referencia <strong>es esencial para procesar tu pago</strong> y activar los servicios asociados."
    },
    details: {
      title: "Desde cualquier banco",
      subtitle: "Accede a la sección de transferencias o pagos a otros bancos y proporciona los siguientes datos:",
      banco: {
        label: "Banco destino:",
        text: "STP <small>(Sistema de Transferencias y Pagos)</small>",
      },
      clabe: {
        label: "Cuenta CLABE:",
        copy:{
          success: '¡CLABE Copiada!'
        }
      },
      referencia: {
        label: "Referencia (N° Orden):",
        text: "ORDEN NO. ",
        copy:{
          success: '¡Referencia Copiada!'
        }
      },
      importe: {
        label: "Importe:",
      },
    },
    instructions: {
      title: "Instrucciones",
      li_1: 'Después de completar el pago, haz clic en "<strong>Continuar</strong>" y serás redirigido al panel de control.',
      li_2: "Una vez allí, podrás revisar los detalles de tus servicios y realizar cualquier configuración adicional que necesites.",
      li_3: "Tus servicios se activarán automáticamente una vez que recibamos y validemos el pago.",
      li_4: 'Si tienes alguna pregunta sobre tu pago o necesitas ayuda, visita nuestro <a href="http://" target="_blank" rel="noopener noreferrer">Centro de Ayuda</a>.',
    },
  },
  oxxoPay: {
    head: 'FICHA DIGITAL. NO ES NECESARIO IMPRIMIR.',
    title: '¡Gracias por elegir a NEUBOX!',
    description: 'Para completar tu compra, muestra este comprobante en cualquier tienda Oxxo del país. Indica al cajero el valor exacto indicado, ya sea en formato impreso o digital. Sin esta información, no podremos validar tu compra.',
    mountText: 'Monto de la compra',
    mountDisclaimer: '* OXXO cobrará una comisión adicional al momento de realizar el pago.',
    details: 'Detalles de tu compra',
    orgName: 'Nombre de la organización',
    expiryDate: 'Fecha de expiración',
    concept: 'Concepto',
    detailsDisclaimer: 'Solicita al cajero escanear este código o puedes dictarle el número que aparece debajo del codigo de barras',
    reference: 'Referencia',
    instructions: {
      title: 'Instrucciones',
      one: 'Dirígete a la tienda OXXO más cercana.',
      oneLine: 'Encuentra uno cerca de ti aquí.',
      two: 'Presenta el recibo de pago, ya sea impreso o en tu celular, al cajero de OXXO y solicita que escanee el código de barras del mismo.',
      three: 'Realiza el pago correspondiente con',
      threeBlack: 'dinero en efectivo.',
      four: 'Al confirmar tu pago, el cajero te entregará un comprobante impreso. En el podrás verificar que se haya realizado correctamente.',
      fourBlack: 'Conserva este comprobante de pago.',
      five: 'Tu pago se verá reflejado automáticamente por lo que no es necesario enviar tu comprobante.',
      last: 'Al completar estos pasos recibirás un correo de <b>NEUBOX</b> confirmando tu pago.'
    },
    printText: 'Imprimir Ficha'
  },
  // PayPalPlus
  ppp: {
    text: 'Para completar tu compra mediante <strong>PayPal Plus</strong>, ingresa los datos de tu tarjeta para finalizar con la compra.',
    address: {
      tus_datos: 'Tus Datos'
    },
    details_invoice: {
      title: 'Detalles de Compra',
      table: {
        header_left: 'Descripción / Articulo',
        header_right: 'Precio',
        subtotal: 'Subtotal',
        iva: 'IVA @ 16.00%',
        total: 'Total',
      }
    },
    btn: {
      continue: 'Realizar Pago' 
    },
    error: {
      payment:{
        pending: 'Su pago ha entrado a un estado de revisión manual, sus servicios quedarán activos en cuanto terminemos de verificar la transacción ésto puede demorar al rededor de 24 horas. Agradecemos su paciencia.'
      }
    }
  },
  paymentConfirm: {
    thanks: "¡Muchas Gracias!",
    bodyText: {
      title: "Tu pago ha sido procesado con éxito.",
      subtitle: "Te recordamos que también puedes generar la factura de tu pago desde tu Panel de Cliente."
    },
    textnote: "Recibo de compra:",
    redirectText: "Redirigiendo a tu panel de cliente:"
  },
  //Componente registro y login
  login: {
    btnText: 'Iniciar sesión',
    rememberData: 'Recordar mis datos',
    forgetPass: '¿Olvidaste tu contraseña?',
    stillAccount: '¿Aún no tienes cuenta?',
    registerText: 'Registrarme',
    errors: {
      emptyTexts: 'Email y/o password NO deben de ser vacíos'
    }
  },
  signUp:{
      title: 'Ingresa tus Datos',
      titleLogedin: 'Tus Datos',
      subtitle: 'Para continuar con tu compra, necesitas iniciar sesión en tu cuenta o registrarte como nuevo usuario.',
      passwordSecurity: 'Seguridad de contraseña: ',
      passwordStrength: '',
      security: {
        default: '-',
        low: "Muy baja",
        medium: "Moderada",
        high: "Alta"
      },
      fields: {
        name: 'Nombre',
        lastName: 'Apellido',
        email: 'Correo Electrónico',
        password: 'Contraseña',
        passwordRepeat: 'Repetir Contraseña',
      },
      validate: {
        verifyText: 'Por favor, verifique los campos del formulario.',
        verifyEmail: 'Formato de correo electrónico no válido. Ejemplo: nombre@dominio.com',
        empty: {
          default: 'Este campo es obligatorio.',
          lastname: 'Por favor, ingresa un apellido válido.',
          firstname: 'Por favor, ingresa tu nombre.',
          password: 'Por favor, ingresa tu contraseña.',
          email: 'Por favor, ingresa tu correo electrónico.'
        },
        characters: {
          lastname: 'Tu Apellido sólo podrá contener letras.',
          firstname: 'Tu Nombre sólo podrá contener letras.'
        },
        short: {
          lastname: 'Tu Apellido debe tener al menos 3 caracteres.',
          firstname: 'Tu Nombre debe tener al menos 3 caracteres.',
          password: 'La contraseña debe tener al menos 8 caracteres.'
        },
        notMatch: 'Las contraseñas no coinciden , favor de verificarlas.'
      },
      createAccount: 'Crear nueva cuenta',
      warningText: 'Es esencial que ingreses <b>un nombre válido</b> para el registro de tu cuenta. Más adelante, tendrás la posibilidad de cambiarlo desde tu panel de clientes. Recuerda que todos los campos son obligatorios.',
      haveAccount: '¿Ya tienes una cuenta?',
      signHere: ' Ingresa aquí',
      tooltip: {
        title: 'Consejos Útiles',
        description1: '* Utilice ambos caracteres, <b>mayúsculas y minúsculas.</b>',
        description2: '* Utilice al menos <b>un símbolo</b> (#$!%& etc...).',
        description3: '* No utilice palabras del diccionario.'

      },
  },
  //Componente Recuperación de contraseña
  recoverPass: {
    title: 'Recuperación de contraseña',
    description: 'Introduce el correo electrónico que utilizaste para registrar tu cuenta, para que podamos enviarte un enlace para restablecer tu contraseña.',
    recoverText: 'Restablecer contraseña',
    returntoLogin: 'Regresar al inicio de sesión',
    screenReview: {
      title: 'Revisa tu bandeja de correo',
      description: 'Se ha enviado un enlace para restablecer tu contraseña a tu correo electrónico. Por favor, revisa tu bandeja de entrada y sigue las instrucciones para recuperar el acceso a tu cuenta.',
      accept: 'Aceptar'
    }
  },
  //Componente Mi carrito
  myCart: {
    headers: {
      products: 'Productos',
      period: 'Período',
      price: 'Precio',
      actions: 'Acciones'
    },
    title: 'Mi carrito',
    clearCartbtn: 'Vaciar Carrito',
    disclaimer: 'Oculta tus datos de contacto registrante en consultas WHOIS y protégete contra robo de identidad y spam.',
    privacyProtect: 'Privacidad de Dominio en WHOIS - ',
    disclaimernbps: 'Por favor, ten en cuenta que <b>el producto NBP no se puede combinar con otros productos en el carrito.</b> Asegúrate de que sea <b>el único artículo</b> en tu carrito, de lo contrario, no podrás completar la compra.'
},
  //Componente Lista de metodos de pago
  listPayments: {
    title: 'Seleccionar Método de Pago',
    subtitle: 'Elige el método de pago que prefieras para completar tu compra de forma segura.',
    evo: {
      title: 'Tarjeta de Crédito / Débito',
      description: 'Paga con tu tarjeta de crédito o débito. Tu servicio se activará de inmediato tras la confirmación de pago.'
    },
    paypal: {
      title: 'Cuenta PayPal',
      description: 'Paga con tu cuenta PayPal. La activación de servicios es inmaediata. Al completar tu pedido, serás redirigido a PayPal para realizar el pago de tu compra.'
    },
    paypalPlus: {
      title: 'Tarjeta de Crédito / Débito vía Paypal',
      description: 'Paga con tu tarjeta de crédito o débito con la seguridad de PayPal sin necesidad de tener cuenta. Al completar tu pedido, serás redirigido a PayPal para realizar el pago de tu compra.'
    },
    oxxo: {
      title: 'OXXO Pay',
      description: 'Realiza tu pago en la sucursal OXXO de tu preferencia. Una vez realizado el pago, puede tardar de 15 a 20 minutos en reflejarse. Si presentas algún inconveniente con el estatus de tu pago, por favor envíanos un ticket desde tu Panel de Clientes al departamento de Atención a Clientes, indicando el número de recibo y adjuntando tu comprobante de pago',
    },
    spei: {
      title: 'Transferencia Electrónica SPEI',
      description: 'Transferencia Electrónica Interbancaria referenciada vía SPEI. La activación de los servicios es inmediata. Asegúrate de ingresar correctamente el número de referencia indicado.',
    },
    nbp: {
      apply: 'Aplicar',
      text: 'NEUBOXPOINTS (NBP)',
      description: 'Ahora podrás usar el beneficio de tus compras para el pago total o parcial de tus nuevos servicios(1 NBP = 1 MXN)'
    },
    saf: {
      title1: "Aplicar",
      title2: "del saldo a favor de mi cuenta NEUBOX",
      description: 'Pagar con mi saldo a favor de mi cuenta en NEUBOX. La Activación de servicios es inmediata.'
    }
  },
  // mensajes de modales sweet
  swal:{
    btn:{
      confirm: "Aceptar",
      cancel: "Cancelar"
    },
    cart: {
      uSure: '¿Estás seguro?',
      clear: '¿Deseas vaciar el carrito?',
      confirm: 'Sí, vaciar.',
      cancel: 'No, cancelar.',
      success: '¡Éxito!',
      clearCart: 'Se ha limpiado el carrito.',
      item: {
        clearProduct: '¿Deseas eliminar este producto?',
        delete: 'Sí, eliminar.',
        deleteSuccess: 'Se ha eliminado este producto',

      }
    }
  },
  // errores 
  error:{
    session:{
      title: 'Error de autenticación',
      text: 'Por favor, verifica tus credenciales y vuelve a intentarlo.'
    },
    connection:{
      title: 'Error de conexión',
      text:'No se puede conectar al servidor. Por favor, verifica tu conexión a internet y vuelve a intentarlo.'
    },
    time:{
      title: 'Tiempo de Espera Excedido',
      text: 'La solicitud ha tardado demasiado. Por favor, inténtalo de nuevo.'
    },
    500:{
      title: "Error de Servidor Interno",
      text: "Ocurrió un error en el servidor. Por favor, inténtalo de nuevo más tarde."
    },
    transaction: {
      title: "Problema en la Transacción",
      text: "¡Ups! Algo salió mal con tu pago. Revisa los detalles y vuelve a intentarlo desde tu recibo."
    }
  },
  //resumen
  resumen:{
    header:{
      title: "Resumen de Compra"
    },
    content:{
      nodomain: "Sin Dominio asignado",
      gratis: "Gratis el primer año",
      gratish: "Gratis con tu plan de Hosting",
      privacidad: "Privacidad de Dominio en WHOIS",
      aplicar: "Aplicar",
      eliminar: "Eliminar",
      descuento: "Descuento",
      codigo: "Ingresa un código promocional",
      nbxPoints: 'NEUBOX Points',
      optin1: "Recibe las mejores ofertas y actualizaciones",
      optin2: "Acepto recibir correos informativos sobre productos y ofertas promocionales.",
      optin3: "Puedes desuscribirte en cualquier momento.",
      protegidas: "Todas tus compras están protegidas con"
    }
  },
  //Componente de DomainSearch
  domainsearch: {
    successDomain: "Felicitaciones, podemos transferir {{domainName}} hacia nosotros por sólo ${{price}} {{currency}}.",
    errors:{
      adderror: 'Error al intentar agregar el dominio',
      brownerror: 'El Dominio buscado ya ha sido registrado',
      alreadydomain: 'Ya has agregado este dominio'
    }
  },
  //header
  header: {
    btn:{
      back: 'Seguir comprando',
      user: 'Ingresar'
    },
    sing: {
      panel: "Ir a Panel de clientes",
      cerrar: "Cerrar sesión"
    },
    drawer: {
      title: 'Mi carrito',
      url: {
        hosting: 'Ver planes Hosting',
        domains: 'Busca y registra tu nuevo Dominio'
      },
      text: {
        empty: 'Descubre las mejores opciones para impulsar tu proyecto online al mejor precio.',
      },
      btn: {
        checkout: 'Completar e ir al carrito',
      }
    }
  },
  // footer
  footer:{
    payment_methods: "Métodos de pago:"
  },
  session_expired: {
    title: 'Tu sesión ha expirado',
    text1: 'Tu sesión ha expirado debido a inactividad. ',
    text2: 'Por favor, vuelve a iniciar sesión para continuar.',
    btn: 'Aceptar'
  }
};

export default translation;
